import React from 'react';
import { useNavigate } from 'react-router-dom';

const DefaultModal = ({
  heading,
  MainData,
  SecondaryData,
  ReturnTitle,
  ButtonTitle,
  ButtonLink,
  handleTabChange,
}) => {
  const navigate = useNavigate();
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
      <div className="bg-blue-400 bg-opacity-90 p-12 rounded-lg">
        <p className="text-white font-bold text-4xl mb-8">{heading}</p>
        <p className="text-white font-light text-xl mb-1">{MainData}</p>
        <p className="text-white font-[50] text-l mb-10 ">{SecondaryData}</p>
        <p className="text-white font-semibold text-xl text-center mb-2">
          {ReturnTitle}
        </p>
        <div className="flex justify-center">
          <button
            className="bg-white hover:bg-sky-500 text-black font-bold py-2 px-4 rounded-full"
            onClick={() => {
              if (handleTabChange) {
                handleTabChange('select_supplier');
              } else {
                navigate(ButtonLink);
              }
            }}
          >
            {ButtonTitle}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DefaultModal;
